import { Report } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import { loginResult } from "../Interfaces/loginInterfaces";
import {
  ICustomerReportScopeChangePasswordFormValues,
  ICustomerReportScopeDeleteFormValues,
  ICustomerReportScopeSearchParams,
  ICustomerReportScopeTableReport,
  ICustomerReportScopeUpsertFormValues,
} from "../Interfaces/reportLinks";
import { getTable, postRequest } from "./requestTemplates";

export const getCustomerReportScopeTable = (
  searchParam: ICustomerReportScopeSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ICustomerReportScopeTableReport>> =>
  getTable<
    ICustomerReportScopeSearchParams,
    ICustomerReportScopeTableReport
  >("/v1/reportlinks/table", searchParam, offset, pageSize, sortingType);

export const upsertCustomerReportScope = (
  formValues: ICustomerReportScopeUpsertFormValues,
): Promise<Packet<boolean>> =>
  postRequest("/v1/reportlinks/upsert", formValues);

export const deleteCustomerReportScope = (
  formValues: ICustomerReportScopeDeleteFormValues,
): Promise<Packet<boolean>> =>
  postRequest("/v1/reportlinks/delete", formValues);

export const changeCustomerReportScopePassword = (
  formValues: ICustomerReportScopeChangePasswordFormValues,
): Promise<Packet<boolean>> =>
  postRequest("/v1/reportlinks/changePassword", formValues);

export const impersonateCustomerReportScope = (formValues: {
  id: number;
}): Promise<loginResult> =>
  postRequest("/v1/reportlinks/impersonate", formValues);
